import { Injectable } from '@angular/core';
import { FieldType, FilterFormDataModel, FormField, WidthClass } from '@thehubz/client/core';
import { FilterFormsComponent } from '../filter-forms/filter-forms.component';
import { take } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AnyType } from '@thehubz/shared/model';

@Injectable()
export class NavigationTabService {
  constructor(private dialog: MatDialog) {}

  /**
   * Add new tabs
   */
  addTabs(filterFormData: FilterFormDataModel, dialogDataConfig: { filterType: string; usersFieldType: string }, selectedFilterData?: AnyType) {
    const filterProjectFormData: FilterFormDataModel = JSON.parse(JSON.stringify(filterFormData));
    const filterNameObj: FormField = {
      formTypeId: '1',
      formFieldName: 'name',
      fieldType: FieldType.Text,
      fieldLabel: $localize`Filter name`,
      placeholder: $localize`:placeholder:Enter filter name`,
      inputType: 'text',
      mandatory: true,
      validationRegex: '',
      widthClass: WidthClass.WFull,
      disable: false,
      functionCall: false,
      visible: true,
      formGroup: true,
    };
    filterProjectFormData.formFields.unshift(filterNameObj);
    filterProjectFormData.formFields = filterProjectFormData.formFields.map((formF) => {
      return {
        ...formF,
        widthClass: formF.fieldType === FieldType.Dropdown ? WidthClass.W13 : formF.widthClass,
      };
    });
    const dialogRef = this.dialog.open(FilterFormsComponent, {
      minWidth: '23%',
      maxWidth: '50vw',
      maxHeight: '100vh',
      data: {
        filterProjectFormData,
        selectedFilterData,
        dialogHeader: $localize`Create new filter`,
        callFromDialog: true,
        filterType: dialogDataConfig.filterType,
        usersFieldType: dialogDataConfig.usersFieldType,
      },
    });
    dialogRef.disableClose = true;
    return dialogRef.afterClosed().pipe(take(1));
  }
}
